import type React from "react"
import { type ChangeEvent, useState } from "react"
import { TextField, Typography, type TextFieldProps, Popover, Box, IconButton } from "@mui/material"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
interface FormFieldProps {
  label: string
  placeholder: string
  name: string
  value?: string | number
  defaultValue?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  error?: string
  typographySx?: React.CSSProperties
  textFieldSx?: React.CSSProperties
  InputProps?: TextFieldProps["InputProps"]
  multiline?: boolean
  rows?: number
  type?: string
  infoText?: string
  disabled?: boolean
}

export const VerticalFormField: React.FC<FormFieldProps> = ({
  type,
  label,
  infoText,
  placeholder,
  disabled,
  name,
  value,
  defaultValue,
  onChange,
  error,
  typographySx,
  textFieldSx,
  InputProps,
  multiline,
  rows,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "info-popover" : undefined

  return (
    <div style={{ display: "flex", flexDirection: 'column', gap: 10, width: '100%', alignItems: "flex-start" }}>
      <div style={{ width: "30%", minWidth: "300px" }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "24px",
            letterSpacing: "0px",
            textAlign: "left",
            color: "#10383D",
            ...typographySx,
          }}
        >
          {label}
          {infoText && <IconButton onClick={handleClick} aria-describedby={id} size="small">
            <InfoOutlinedIcon sx={{ fontSize: '13px' }} />
          </IconButton>
          }
        </Typography>
      </div>
      <div style={{ width: "100%" }}>
        <TextField
          placeholder={placeholder}
          name={name}
          value={value === 0 ? 0 : value || defaultValue || ""}
          onChange={onChange}
          size="small"
          disabled={disabled}
          type={type}
          fullWidth
          InputLabelProps={{
            shrink: false,
          }}
          error={!!error}
          helperText={error}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: disabled ? "#f5f5f5" : "inherit",
            },
            "& .MuiInputBase-input.Mui-disabled": {
              color: "#000", 
              WebkitTextFillColor: "#000", 
              fontWeight: 500,
              opacity: 1, 
            },
            ...textFieldSx,
          }}
          InputProps={InputProps}
          multiline={multiline}
          rows={multiline ? rows : undefined}
        />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 300 }}>
          <Typography sx={{ fontSize: "12px", lineHeight: 1.4 }}>{infoText}</Typography>
        </Box>
      </Popover>
    </div>
  )
}
